import React from 'react';
import styled from 'styled-components/macro';
import { Button, Typography } from '@deeptrue-frontend/ui';
import { useFormatMessage } from 'components/IntlProvider';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  margin-top: 3rem;
`;

const Title = styled.div`
  position: absolute;
  top: 0;
  left: 0;
`;

const ConfirmButton = styled(Button)`
  background-color: #dc3545;
  border: none;

  &:hover {
    background-color: #821721;
  }
`;

interface Props {
  onConfirm: () => void;
  onCancel: () => void;
  templateName: string | null;
}

const RemoveTemplate = ({ onConfirm, onCancel, templateName }: Props) => {
  const t = useFormatMessage();
  return (
    <Container>
      <Title>
        <Typography padding="1rem">
          {t(
            'templates.base.removeTemplate.title',
            'Are you sure you want to remove template'
          )}
          <br />
          <span style={{ fontWeight: 600 }}>{templateName}</span>?
        </Typography>
      </Title>
      <Footer>
        <ConfirmButton onClick={onConfirm} variant="primary">
          {t('templates.base.confirm', 'Confirm')}
        </ConfirmButton>
        <Button onClick={onCancel} variant="outlined">
          {t('templates.base.cancel', 'Cancel')}
        </Button>
      </Footer>
    </Container>
  );
};

export default RemoveTemplate;
